import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { dimensionConverterMap } from './dimensionPropsToCss'

/**
 * Enriches the converters registry with all Dimension style property converters.
 * Dimension converters handle CSS width and height properties including length, percentage, keyword, and function values.
 */
export function enrichDimensionConverters(): void {
	// Register all dimension converters by their type discriminants
	Object.entries(dimensionConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
